/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_Catalog_OpenInputs */

const cs_property_list_catalog_open = /** @type {(inputs: Property_List_Catalog_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít katalogové PDF`)
};

const en_property_list_catalog_open = /** @type {(inputs: Property_List_Catalog_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open catalog PDF`)
};

/**
* | output |
* | --- |
* | "Open catalog PDF" |
*
* @param {Property_List_Catalog_OpenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_catalog_open = /** @type {((inputs?: Property_List_Catalog_OpenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_Catalog_OpenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_catalog_open(inputs)
	return cs_property_list_catalog_open(inputs)
});